import React from 'react';
import { Box, Grid } from '@mui/material';
import { NurturingMetricsComponent } from 'app/pages/AutopilotPage/components/NurturingMetricsComponent';

type UnsoldMetricsWrapperProps = {
  metrics: any[];
  onClickMetrics: any;
  selectedMetric: any;
  selectedBox: number;
  setSelectedBox: any;
  isLoading?: boolean;
};

export const UnsoldMetricsWrapper = ({
  metrics,
  onClickMetrics,
  selectedMetric,
  selectedBox,
  setSelectedBox,
  isLoading = false,
}: UnsoldMetricsWrapperProps) => {
  // For 3 cards, we need to adjust the Grid layout
  // Instead of modifying the shared component, we'll wrap it
  // and use CSS to override the Grid item width
  return (
    <Box
      sx={{
        width: '100%',
        '& .MuiGrid-item': {
          '@media (min-width: 1200px)': {
            // Override lg={3} to lg={4} for 3 cards per row
            maxWidth: '33.333333%',
            flexBasis: '33.333333%',
          },
        },
        // Center all content in metric cards - target nested structure
        '& .MuiGrid-container': {
          width: '100%',
        },
        '& .MuiGrid-container .MuiGrid-item': {
          width: '100%',
          '& > div': {
            // MetricGridContainerStyledComponent
            width: '100% !important',
            display: 'flex !important',
            justifyContent: 'center !important',
            '& > div': {
              // MetricGridStyledComponent - ensure centered
              alignItems: 'center !important',
              justifyContent: 'center !important',
              width: '100% !important',
              maxWidth: '100% !important',
              display: 'flex !important',
              flexDirection: 'column !important',
              textAlign: 'center !important',
              '& > div': {
                // MetricBoxContainerStyledComponent - center the number container
                justifyContent: 'center !important',
                width: '100% !important',
                maxWidth: '100% !important',
                display: 'flex !important',
                alignItems: 'center !important',
              },
            },
          },
        },
        // Center all typography elements - force full width and center
        '& .MuiGrid-item h2, & .MuiGrid-item h5, & .MuiGrid-item h6': {
          textAlign: 'center !important',
          width: '100% !important',
          maxWidth: '100% !important',
          display: 'block !important',
          margin: '0 auto !important',
          justifyContent: 'center !important',
        },
        // Direct structure targeting - any div that's a direct child of Grid item and contains h2
        '& .MuiGrid-item > div > div > div': {
          // This targets MetricBoxContainerStyledComponent
          justifyContent: 'center !important',
          width: '100% !important',
          maxWidth: '100% !important',
        },
        // Remove any fixed widths from Typography
        '& .MuiTypography-root': {
          width: '100% !important',
          maxWidth: '100% !important',
          textAlign: 'center !important',
        },
      }}
    >
      <NurturingMetricsComponent
        metrics={metrics}
        onClickMetrics={onClickMetrics}
        selectedMetric={selectedMetric}
        selectedBox={selectedBox}
        setSelectedBox={setSelectedBox}
        isLoading={isLoading}
      />
    </Box>
  );
};

